import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import axios from 'axios';
import VueAxios from 'vue-axios';
Vue.use(VueAxios, axios);
import VueSweetalert2 from 'vue-sweetalert2';
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

///////////////////////////////////////// --------------------> INICIA EL REGISTRO DE FUNCIONES GLOBALES
Vue.prototype.$toastMessage = function toastMessage(type, text, duration,position) {
  this.Toast = this.$swal.mixin({
    toast: true, position: position, timerProgressBar: true,
    showConfirmButton: false, timer: duration
  });
  this.Toast.fire({
    icon: type,
    title: text
  });
}
///////////////////////////////////////// --------------------> FINALIZA EL REGISTRO DE FUNCIONES GLOBALES

Vue.config.productionTip = false;



new Vue({
  render: h => h(App),
}).$mount('#app')
